import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeletePensionDialogueData } from '../../../../api/pension-robot/useDeletePensionDialogueData';
import { usePostDialogueData } from '../../../../api/pension-robot/usePostPensionDialogueData';
import { LAST_SECTION_INDEX } from '../../../../config/constants';
import { RobotEnvironmentContext } from '../../../../contexts/general/RobotEnvironmentContext';
import { DeleteProgressModal } from './DeleteProgressModal';
import { PensionProgressSaverContext } from './PensionProgressSaverContext';
import { SaveMarketingModal } from './SaveMarketingModal';
import { Button } from '../../../general/Button';

export const SavingButtons: React.FC<{ pageNum?: number }> = ({ pageNum }) => {
    const { userToken, environment } = useContext(RobotEnvironmentContext);

    const GetSaveButton = () => (environment === 'Marketing' ? <SaveDataButton pageNum={pageNum} /> : <></>);

    const GetDeleteButton = () => <DeleteDataButton />;

    if (!userToken) return <></>;

    return (
        <div className="flex flex-col gap-2 items-start">
            <GetSaveButton />
            <GetDeleteButton />
        </div>
    );
};

const SaveDataButton: React.FC<{ pageNum?: number }> = ({ pageNum }) => {
    const { t } = useTranslation('pension');
    const [saveModalShown, setSaveModalShown] = useState<boolean>(false);
    const query = usePostDialogueData();

    const onClick = () => setSaveModalShown(true);

    const onSaveData = () => query !== undefined && query.refetch();

    return (
        <div>
            <Button buttonType={'internalLinkBlack'} onClick={onClick}>
                {pageNum === LAST_SECTION_INDEX ? t('general-save-result-page') : t('general-save')}
            </Button>
            <SaveMarketingModal isShown={saveModalShown} setIsShown={setSaveModalShown} onSaveData={onSaveData} />
        </div>
    );
};

export const DeleteDataButton: React.FC<{}> = () => {
    const { t } = useTranslation('pension');
    const [deleteModalShown, setDeleteModalShown] = useState<boolean>(false);
    const deleteQuery = useDeletePensionDialogueData();
    const { environment, userTokenIsNew } = useContext(RobotEnvironmentContext);
    const {
        pensionProgressSaverData,
        pensionProgressSaverData: { autoSaveMyBND },
        setPensionProgressSaverData,
    } = useContext(PensionProgressSaverContext);

    const isMyBND = environment === 'MyBND';
    const isMarketing = environment === 'Marketing';
    const renderStartSaving = isMyBND && !autoSaveMyBND;
    const tokenHasSavedData = !(isMarketing && userTokenIsNew) || pensionProgressSaverData.dataIsSavedAtLeastOnce;

    const renderDelete = (isMarketing && tokenHasSavedData) || (isMyBND && autoSaveMyBND);

    const onClickDelete = () => setDeleteModalShown(true);

    const onClickStartSaving = () => setAutoSaveMyBND(true);

    const setAutoSaveMyBND = (val: boolean) =>
        !!setPensionProgressSaverData &&
        setPensionProgressSaverData({ ...pensionProgressSaverData, autoSaveMyBND: val });

    const onDeleteData = () => {
        isMyBND && setAutoSaveMyBND(false);
        deleteQuery.refetch();
    };

    return (
        <div>
            {renderDelete && (
                <Button buttonType={'internalLinkBlack'} onClick={onClickDelete}>
                    {t('general-delete')}
                </Button>
            )}
            {renderStartSaving && (
                <Button buttonType={'internalLinkGreen'} onClick={onClickStartSaving}>
                    {t('general-start-saving')}
                </Button>
            )}
            <DeleteProgressModal
                isShown={deleteModalShown}
                setIsShown={setDeleteModalShown}
                onDeleteData={onDeleteData}
            />
        </div>
    );
};
